import { ErrorBoundary, Profile } from 'shared-ui';

import { getAppVersion } from 'api/auth/auth';
import { QueryKeyEnum } from 'core/global.enum';
import { useQuery } from 'hooks/useQuery/useQuery';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { ChangePasswordContainer } from 'reusable/changePassword/ChangePasswordContainer';

import { LicenseContainer } from './license/LicenseContainer';

export const ProfileContainer = () => {
  const { data: appVersionResponse } = useQuery([QueryKeyEnum.APP_VERSION], getAppVersion);
  const frontendVersion = window.__FRONTEND_VERSION__ || 'development';
  const { perms } = usePermissions();

  const canViewLicense = !!perms?.LICENCJA?.view;

  return (
    <ErrorBoundary>
      <Profile
        backendVersion={appVersionResponse?.version || ''}
        frontendVersion={frontendVersion}
        changePasswordComponent={<ChangePasswordContainer />}
        additionalSections={canViewLicense ? <LicenseContainer /> : undefined}
      />
    </ErrorBoundary>
  );
};
